﻿<script lang="ts" setup>
    import { type DataGroup } from './Contact.access';
    import { formatDateTime } from '@cwd/Shared/utils/formatDateTime';

    const props = defineProps<{
        dataGroups: DataGroup[];
    }>();
</script>

<script lang="ts"></script>

<template>
    <h2 class="h4">{{ $Resources.ContactModalDataPointHeading }}</h2>

    <ul class="list-unstyled">
        <li v-for="dataGroup in props.dataGroups">
            <h3 class="h5">{{ dataGroup.ObjectGroup }}</h3>

            <ul class="list-unstyled group-values-grid m-lg-b group-values">
                <li v-for="Value in dataGroup.Values">
                    <span class="label-look d-block">{{ Value.Key }}:</span>

                    <span v-if="Value.TextValue">{{ Value.TextValue }}</span>
                    <span v-if="Value.DateValue">{{ formatDateTime(Value.DateValue) }}</span>
                    <span v-if="Value.NumericValue">{{ Value.NumericValue }}</span>
                    <span v-if="Value.BoolValue">{{ Value.BoolValue }}</span>
                </li>
            </ul>
        </li>
    </ul>
</template>

<style>
    .group-values-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(270px, 1fr));
        gap: var(--ug-spacing-xs);
    }

    .group-values > li {
        background-color: var(--brand-hover-color);
        padding: var(--ug-spacing-sm) var(--ug-spacing-md);
        border-radius: var(--border-radius);
    }
</style>
